:host {
  display: block;
  background: var(--cms-semanticColors-container-weak-background);
  margin-bottom: var(--cms-spacing-075);
  position: relative;
  min-height: var(--cms-spacing-300);
  width: var(--cms-container-width);
  @include cms-base-font-100;
}

ul,
li {
  margin: 0;
  padding: 0;
}

.keywords-container {
  display: block;
  background: var(--cms-semanticColors-container-weak-background);
}

.keyword-list-item {
  margin: 0 0 var(--cms-spacing-025);
  padding: var(--cms-spacing-050);
  list-style-type: none;
  cursor: pointer;
  color: var(--cms-semanticColors-base-strong-text);

  &:hover {
    background-color: var(--cms-semanticColors-transparency-strong-hover-background);
  }

  &.active {
    background-color: var(--cms-semanticColors-transparency-strong-hover-background);
  }
}

details>summary {
  list-style: none;
  align-items: center;
  cursor: pointer;
  outline: 0;
  position: relative;
  padding: var(--cms-spacing-075) var(--cms-spacing-100);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: var(--cms-semanticColors-transparency-strong-background);
  @include label-font-125;
}

details>summary:hover,
details.is-open>summary:hover {
  background: var(--cms-theme-strong-hover);
}

details>summary:active,
details.is-open>summary:active {
  background: var(--cms-theme-strong-active-background);
}

details>summary:focus {
  box-shadow: 0 0 0 var(--cms-spacing-025) var(--cms-theme-focus-outline);
}

details.is-open>summary {
  background: var(--cms-theme-strong-active-background);
}

details>summary::-webkit-details-marker {
  display: none;
}

.filter-details {
  height: auto;
  border: var(--cms-border-size-xs) solid var(--cms-semanticColors-base-weak-border);
  overflow: hidden;
  transition: height 300ms ease-in-out;
  background-color: var(--cms-semanticColors-container-weak-background);
  top: 0;
  width: var(--cms-default-width);
  z-index: 1000;
}

.filter-headline {
  color: var(--cms-semanticColors-base-strong-text);
  padding-right: var(--cms-spacing-050);
}

.svg-icon-wrapper {
  display: flex;
  flex-flow: row nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  height: var(--cms-spacing-150);
}

@include media-width($breakpoint-sm) {
  .filter-details {
    position: absolute;
  }
}